/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import useAsegurados from 'redux/hooks/emision/useAsegurados';

const ModalAgregarAsegurado = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setParentesco(null);
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const [parentesco, setParentesco] = useState(null);
  const [showError, setShowError] = useState(false);

  const {
    parentescos,
    disabledBtnAgregar,
    setShowFormAdd,
    isShowFormAdd,
  } = useAsegurados();

  const btnAgregar = useMemo(
    () => (
      <React.Fragment>
        <Button
          icon="pi pi-plus"
          className="p-button-primary"
          disabled={isShowFormAdd || disabledBtnAgregar}
          onClick={handleShow}
        />
        <h4 className="my-auto ml-1" style={{ fontSize: '20px' }}>
          {!disabledBtnAgregar && 'Quiero agregar asegurados'}
          {disabledBtnAgregar && 'Se ha completado el ingreso de asegurados'}
        </h4>
      </React.Fragment>
    ),
    [disabledBtnAgregar, isShowFormAdd],
  );

  const onClickAgregar = () => {
    if (parentesco) {
      handleClose();
      return setShowFormAdd(true, parentesco);
    }
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  };

  const modal = useMemo(
    () => (
      <Modal
        show={show}
        onHide={handleClose}
        centered
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Agregar asegurado</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-3">
          <label htmlFor="parentesco" className="mt-5" style={{ fontSize: '17px' }}>
            Seleccione el tipo de asegurado
          </label>
          <Dropdown
            inputId="parentesco"
            className="w-100"
            value={parentesco}
            options={parentescos}
            onChange={(e) => setParentesco(e.value)}
            placeholder="Seleccione el tipo de asegurado que va a registrar"
          />
          {showError && (
            <h4 className="error-msg-input">Debe seleccionar un parentesco</h4>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-atras-api" onClick={handleClose}>
            Cerrar
          </button>
          <button className="btn btn-sm btn-siguiente-api" onClick={onClickAgregar}>
            Agregar
          </button>
        </Modal.Footer>
      </Modal>
    ),
    [parentescos, parentesco, disabledBtnAgregar, show],
  );

  return (
    <div className="d-flex flex-row flex-wrap">
      {btnAgregar}
      {modal}
    </div>
  );
};

export default ModalAgregarAsegurado;
